import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
	fetchUserCompanies,
	fetchUserFullNames,
	fetchUserPage,
	fetchUserRoles,
} from '../../../state/api/userAPI';
import TableWithFilter from '../../widget/TableWithFilter';
import { dateToString } from '@result/result-ui-components/src/utils/DateUtils';
import Select from '@result/result-ui-components/src/components/Select';
import userRoles from '../../../model/userRoles';
import ApiClient from '../../../state/api/ApiClient';
import Modal from '../../widget/Modal';
import PromiseBuilder from '../../../utils/PromiseUtils';
import {useDispatch, useSelector} from 'react-redux';
import {
	addErrorNotification,
	addSuccessNotification,
} from '../../../state/notification/notifications';
import {setUserListFilter} from "../../../state/filter/filterValues";

function UserList() {
	const { t } = useTranslation();
	const roles = userRoles();
	const [showConfirmationModal, setShowConfirmationModal] = useState(false);
	const [selectedUser, setSelectedUser] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const dispatch = useDispatch();
	const [refetch, setRefetch] = useState(false);


	const initialFilterFromStore = useSelector((state) => state.filterValues.userListFilter);
	const [initialFilter] = useState(initialFilterFromStore);


	const handleRoleChange = () => {
		if (!selectedUser) return;
		setIsLoading(true);
		const request = async () =>
			ApiClient.put(`/api/profile-admin/users/${selectedUser.id}/role`, {
				role: selectedUser.role,
			});

		new PromiseBuilder()
			.then(request)
			.then(async (data) => {
				setShowConfirmationModal(false);
				setIsLoading(false);
				setRefetch(true);
				dispatch(
					addSuccessNotification({
						title: t('update_success_title'),
						content: t('update_success_content'),
					})
				);
			})
			.then(() => {})
			.catch(async (err) => {
				setShowConfirmationModal(false);
				setIsLoading(false);
				dispatch(
					addErrorNotification({
						title: t('update_fail_title'),
						content: t('update_fail_content'),
					})
				);
			})
			.run();
	};

	return (
		<>
			<TableWithFilter
				filterIcon="icon-filter"
				selector={(state) => state.userAPI.list}
				fetchAction={fetchUserPage}
				disableOnClick={true}
				refetchData={refetch}
				onDataRefetched={() => {
					setRefetch(false);
				}}
				initialFilter={initialFilter}
				onFilter={(filter, formValues) => {
					dispatch(setUserListFilter(formValues));
				}}
				columns={[
					{
						name: t('fullname'),
						id: 'lastName',
						cellComponent: (entry) => (
							<div>
								{`${
									!entry.firstName && !entry.lastName
										? '/'
										: (entry?.firstName ?? '') + ' ' + (entry?.lastName ?? '')
								}`}
							</div>
						),
					},
					{
						name: t('email'),
						id: 'email',
					},
					{
						name: t('role'),
						id: 'role',
						cellComponent: (entry) => (
							<form className={`user-roles is-${entry?.role}`}>
								<Select
									options={roles}
									optionsLabel={'label'}
									optionsCode={'key'}
									optionsValue={'key'}
									selectedItem={entry?.role}
									onChange={(role) => {
										setSelectedUser({ ...entry, role });
										setShowConfirmationModal(true);
									}}
								/>
							</form>
						),
					},
					// {
					// 	name: t('access'),
					// 	id: 'access',
					// 	cellComponent: (entry) => (
					// 		<>
					// 			{entry.access?.length > 0
					// 				? entry.access
					// 						.map((type) => t('applications.' + type))
					// 						.join(', ')
					// 				: '/'}
					// 		</>
					// 	),
					// },
					{ name: t('company'), id: 'company' },
					{
						name: t('active_date'),
						id: 'lastLogin',
						cellComponent: (entry) => (
							<div>{dateToString(entry.lastLogin, false, true)}</div>
						),
					},
				]}
				filterColumns={[
					{
						name: t('full_name'),
						type: 'inputtag',
						id: 'fullName',
						selector: [(state) => state.userAPI.fullNames],
						fetchAction: [fetchUserFullNames],
					},
					{
						name: t('role'),
						type: 'inputtag',
						id: 'role',
						isTranslated: true,
						translationKey: 'user_roles',
						selector: [(state) => state.userAPI.roles],
						fetchAction: [fetchUserRoles],
					},
					{
						name: t('company'),
						type: 'inputtag',
						id: 'company',
						selector: [(state) => state.userAPI.companies],
						fetchAction: [fetchUserCompanies],
					},
					{
						name: 'last_login',
						type: 'date',
						id: 'lastLogin',
					},
				]}
			/>
			{selectedUser && (
				<Modal
					title={t('confirmation_needed')}
					content={t('user_role_change_confirm', {
						user: selectedUser.firstName + ' ' + selectedUser.lastName,
						role: t('user_roles.' + selectedUser.role),
					})}
					showPopup={showConfirmationModal}
					label={t('confirmation_needed')}
					confirmButtonLabel={t('confirm')}
					onConfirm={handleRoleChange}
					cancelButtonLabel={t('close')}
					onCancel={() => {
						setSelectedUser(null);
						setShowConfirmationModal(false);
					}}></Modal>
			)}
		</>
	);
}

export default UserList;
